import { Controller, useFormContext } from "react-hook-form";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

// ----------------------------------------------------------------------
export function RHFSelect({
  name,
  native,
  maxHeight = 220,
  helperText,
  children,
  PaperPropsSx,
  defaultValue,
  placeholder,
  rules = {},
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ""}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error}>
          <InputLabel id={`${name}-label`}>{placeholder}</InputLabel>
          <Select
            labelId={`${name}-label`}
            id={`${name}-select`}
            label={placeholder}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                legend: {
                  span: {
                    color: "red",
                  },
                },
              },
            }}
            value={field.value || ""}
            onChange={(e) => field.onChange(e.target.value)}
          >
            {children}
          </Select>
        </FormControl>
      )}
    />
  );
}
